
import { types } from "../types"

//************************************************************************************** */
export const getInstruction = (params) => {
    return {
        type: types.GET_INSTRUCTION_REQUEST,
        params
    }
}
export const resetPropsGetIstruction = () => {
    return {
        type: types.GET_INSTRUCTION_RESET_PROPS,
    }
}
//***************************************************************************************** */
export const getCustomerNumber2 = (params) => {
    return {
        type: types.GET_CUSTOMER_MEMBER2_REQUEST,
        params
    }
}
export const resetCustomerNumber2 = () => {
    return {
        type: types.GET_CUSTOMER_NUMBER2_RESET_PROPS,
    }
}
//****************************************************************************************** */
export const saveInstruction = (params) => {
    return {
        type: types.SAVE_INSTRUCTION_REQUEST,
        params
    }
}
export const resetSaveInstruction = () => {
    return {
        type: types.SAVE_INSTRUCTION_RESET_PROPS,

    }
}
//****************************************************************************************** */
export const getCustomerMember = () => {
    return {
        type: types.GET_CUSTOM_MEMBER_REQUEST,
    }
}
export const resetGetCustomerMember = () => {
    return {
        type: types.GET_CUSTOM_MEMBER_RESET_PROPS,
    }
}

